export default "__VITE_ASSET__COot$iBJ__"